import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useReader, useReaderHighlights, useReaderSelection } from './reader.js';
const DEFAULT_COLORS = ['#ffd54a', '#7bd88f', '#7cc4ff', '#ff9db1'];
function jumpTargetOf(h) {
    if (h.kind === 'rect')
        return h.page;
    return {
        type: 'anchor',
        spine: h.range.spine,
        block: h.range.startBlock,
        offset: h.range.startOffset,
        percent: 0,
    };
}
/**
 * The book's highlights as an editable list — jump to one, recolour it, attach
 * or edit a note, delete it. Headless like {@link TableOfContents}: it renders
 * a plain `<ol>` with `data-pore-hl-*` hooks and no dialog chrome of its own;
 * the host wraps and styles it. Renders nothing on engines without highlights.
 */
export function HighlightsPanel({ className, emptyLabel = 'Select text in the book to highlight it.', colors = DEFAULT_COLORS, onJump, previewChars = 90, }) {
    const highlights = useReaderHighlights();
    const { goto } = useReader();
    const { updateHighlight, removeHighlight } = useReaderSelection();
    if (highlights.length === 0) {
        return (_jsx("p", { ...(className ? { className } : {}), "data-pore-hl-empty": true, children: emptyLabel }));
    }
    return (_jsx("ol", { ...(className ? { className } : {}), "data-pore-hl-list": true, children: highlights.map((h) => (
        // remount when colour/note change out from under us (e.g. another tab)
        _jsxs("li", { "data-pore-hl-item": true, children: [_jsx("button", { type: "button", "data-pore-hl-jump": true, style: { borderInlineStartColor: h.color }, onClick: () => {
                        goto(jumpTargetOf(h));
                        onJump?.(h);
                    }, children: h.text.length > previewChars ? `${h.text.slice(0, previewChars)}…` : h.text }), _jsx("div", { "data-pore-hl-colors": true, role: "group", "aria-label": "Highlight colour", children: colors.map((c) => (_jsx("button", { type: "button", "data-pore-hl-swatch": true, "aria-label": `Recolour to ${c}`, "aria-pressed": h.color === c, style: { background: c }, onClick: () => updateHighlight(h.id, { color: c }) }, c))) }), _jsx("textarea", { "data-pore-hl-note": true, "aria-label": "Note", placeholder: "Add a note\u2026", defaultValue: h.note ?? '', rows: 2, onBlur: (e) => {
                        const next = e.target.value.trim();
                        if (next !== (h.note ?? ''))
                            updateHighlight(h.id, { note: next });
                    } }, h.note ?? ''), _jsx("button", { type: "button", "data-pore-hl-remove": true, "aria-label": "Remove highlight", onClick: () => removeHighlight(h.id), children: "\u00D7" })] }, `${h.id}:${h.color}:${h.note ?? ''}`))) }));
}
//# sourceMappingURL=highlights-panel.js.map